import { format, isToday, isYesterday, isThisYear } from "date-fns";
import { fr } from "date-fns/locale";

export function getMessageTimestamp(message) {
  const t = new Date(message?.created_at || 0).getTime();
  return Number.isFinite(t) ? t : 0;
}

/** Tri chronologique ascendant (ancien → récent), comme WhatsApp / Messenger */
export function sortMessagesChronologically(messages) {
  return [...messages].sort((a, b) => {
    const diff = getMessageTimestamp(a) - getMessageTimestamp(b);
    if (diff !== 0) return diff;
    return String(a.message_id).localeCompare(String(b.message_id));
  });
}

function dayKey(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "unknown";
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

export function formatChatDateLabel(iso) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";

  if (isToday(date)) return "Aujourd'hui";
  if (isYesterday(date)) return "Hier";

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const msgDay = new Date(date);
  msgDay.setHours(0, 0, 0, 0);
  const diffDays = Math.floor((today.getTime() - msgDay.getTime()) / 86400000);
  if (diffDays > 1 && diffDays < 7) {
    return format(date, "EEEE", { locale: fr }).replace(/^\w/, (c) => c.toUpperCase());
  }
  if (isThisYear(date)) {
    return format(date, "d MMMM", { locale: fr });
  }
  return format(date, "d MMMM yyyy", { locale: fr });
}

/**
 * Construit une timeline avec séparateurs de date entre les jours.
 * @returns {Array<{type: 'date', id: string, label: string} | {type: 'message', id: string, message: object}>}
 */
export function buildChatTimeline(messages) {
  const sorted = sortMessagesChronologically(messages);
  const items = [];
  let lastDay = null;

  for (const message of sorted) {
    const key = dayKey(message.created_at);
    if (key !== lastDay) {
      items.push({
        type: "date",
        id: `date-${key}`,
        label: formatChatDateLabel(message.created_at),
      });
      lastDay = key;
    }
    items.push({
      type: "message",
      id: message.message_id,
      message,
    });
  }

  return items;
}

export function formatConversationPreviewTime(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";

  if (isToday(date)) {
    return format(date, "HH:mm", { locale: fr });
  }
  if (isYesterday(date)) return "Hier";
  if (isThisYear(date)) {
    return format(date, "d MMM", { locale: fr });
  }
  return format(date, "dd/MM/yy", { locale: fr });
}